module.exports = __webpack_public_path__ + "img/icon-implantation-04.6e35e196.svg";